__turbopack_context__.v({
  "homeReviewsQuoteItems": "home-reviews-module-scss-module__W3paUW__homeReviewsQuoteItems",
  "homeReviewsVideoItems": "home-reviews-module-scss-module__W3paUW__homeReviewsVideoItems",
});
